import { render } from "./UiPropPaddings.vue?vue&type=template&id=acf945e4&scoped=true"
import script from "./UiPropPaddings.vue?vue&type=script&lang=js"
export * from "./UiPropPaddings.vue?vue&type=script&lang=js"

import "./UiPropPaddings.vue?vue&type=style&index=0&id=acf945e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf945e4"]])

export default __exports__